// extracted by mini-css-extract-plugin
export var acitonButtons = "_h8-0";
export var additionalIcon = "_h8-f";
export var block = "_h8-1";
export var blockContent = "_h8-7";
export var blockDescription = "_h8-8";
export var blockIcon = "_h8-9";
export var blockTitle = "_h8-6";
export var border = "_h8-a";
export var center = "_h8-l";
export var edge = "_h8-b";
export var edgeLabel = "_h8-c";
export var edgePath = "_h8-d";
export var error = "_h8-e";
export var flowchart = "_h8-g";
export var flowchartContent = "_h8-h";
export var highlighted = "_h8-3";
export var hover = "_h8-4";
export var icon = "_h8-i";
export var left = "_h8-m";
export var navButton = "_h8-j";
export var navButtons = "_h8-k";
export var right = "_h8-n";
export var selected = "_h8-2";
export var small = "_h8-5";